<template>
  <div>
    <div
      class="hero"
      style="
        background: url('/images/investorImage.png') lightgray center center /
          cover no-repeat;
      "
    >
      <div class="overlay">
        <div class="container">
          <div
            class="content d-flex flex-column align-items-center justify-content-center p-0"
          >
            <h1 class="text-center">Investor Relations</h1>
            <p class="text-center paragraph-width">
              Transparent, disciplined, and long-term—connecting patient capital
              with diversified opportunities and robust governance.
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="about" style="padding-block: 100px">
      <div class="container">
        <div
          class="row align-items-center"
          style="row-gap: 40px; overflow: hidden"
        >
          <div class="col-lg-6 col-md-6 col-sm-12">
            <div class="d-flex flex-column gap-3">
              <p
                class="mb-0"
                style="color: #ddb657; font-size: 12px; font-weight: 700"
              >
                Investor Relations
              </p>
                  <div class="sub-heading">
                    <h3>Financial Highlights & Future Development Plan</h3>
                  </div>
              <p class="mb-0" style="font-size: 16px; color: #334155">
                Aljabiri Group Holding manages a diversified portfolio with a
                resilient financial structure built on prudence,
                diversification, and long-term stewardship. While detailed
                figures remain confidential, we present high-level indicators to
                demonstrate scale and resilience.
              </p>
              <router-link
                to="/getTouch"
                class="text-white"
                style="
                  font-size: 14px;
                  padding: 8px 14px;
                  border-radius: 10px;
                  background-color: #ddb657;
                  width: fit-content;
                "
              >
                Contact Investor Relations
              </router-link>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12">
            <div class="img mb-3" style="aspect-ratio: 2/1.3; overflow: hidden">
              <img
                src="/images/financialImage.png"
                alt="aboutImage"
                class="w-100 h-100 rounded shadow-sm"
                style="object-fit: cover"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container py-5">
      <!-- Header -->
      <div class="text-center mb-5">
        <h1 class="fw-bold mb-3 text-center">
          Financial Highlights (Illustrative)
        </h1>
        <p class="text-muted text-center">
          Balanced, multi-sector exposure with conservative liquidity and
          governance.
        </p>
      </div>

      <!-- Assets and Revenue Cards -->
      <div class="row g-4 mb-4">
        <!-- Assets Under Management -->
        <div class="col-md-6">
          <div class="info-card p-3">
            <div class="d-flex flex-column gap-3 align-items-start mb-3">
              <div class="d-flex align-items-center w-100">
                <div class="icon-box me-3">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11 15H13C13.5304 15 14.0391 14.7893 14.4142 14.4142C14.7893 14.0391 15 13.5304 15 13C15 12.4696 14.7893 11.9609 14.4142 11.5858C14.0391 11.2107 13.5304 11 13 11H10C9.4 11 8.9 11.2 8.6 11.6L3 17"
                      stroke="#DDB657"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M7 20.9998L8.6 19.5998C8.9 19.1998 9.4 18.9998 10 18.9998H14C15.1 18.9998 16.1 18.5998 16.8 17.7998L21.4 13.3998C21.7859 13.0351 22.0111 12.5321 22.0261 12.0014C22.0411 11.4706 21.8447 10.9557 21.48 10.5698C21.1153 10.1839 20.6123 9.95867 20.0816 9.94367C19.5508 9.92867 19.0359 10.1251 18.65 10.4898L14.45 14.3898"
                      stroke="#DDB657"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M2 16L8 22"
                      stroke="#DDB657"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M15.9996 11.9001C17.6012 11.9001 18.8996 10.6017 18.8996 9.0001C18.8996 7.39847 17.6012 6.1001 15.9996 6.1001C14.398 6.1001 13.0996 7.39847 13.0996 9.0001C13.0996 10.6017 14.398 11.9001 15.9996 11.9001Z"
                      stroke="#DDB657"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M6 8C7.65685 8 9 6.65685 9 5C9 3.34315 7.65685 2 6 2C4.34315 2 3 3.34315 3 5C3 6.65685 4.34315 8 6 8Z"
                      stroke="#DDB657"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <h5 class="fw-bold mb-0 text-start">Assets Under Management</h5>
              </div>
              <p class="text-muted small mb-0 text-start w-100">
                The Group oversees assets valued in the multi-million US dollar
                range, distributed across sectors including trade & logistics,
                financial services, healthcare, real estate, digital
                transformation, and energy. Asset allocation is designed to
                maintain liquidity while generating sustainable returns.
              </p>
            </div>
          </div>
        </div>

        <!-- Revenue Streams -->
        <div class="col-md-6">
          <div class="info-card p-3">
            <div class="d-flex flex-column gap-3 align-items-start mb-3">
              <div class="d-flex align-items-center w-100">
                <div class="icon-box me-3">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3 3V19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21H21"
                      stroke="#DDB657"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M19 9L14 14L10 10L7 13"
                      stroke="#DDB657"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <h5 class="fw-bold mb-0 text-start">Revenue Streams</h5>
              </div>
              <p class="text-muted small mb-0 text-start w-100">
                Revenues are derived from a balanced mix of industries and
                geographies, ensuring that no single sector or region dominates
                overall performance. This aligns with the family's principle of
                avoiding reliance on any one industry or financial system.
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Charts Section -->
      <div class="row g-4 mb-4">
        <!-- Portfolio Composition -->
        <div class="col-lg-6">
          <div class="info-card p-3 bg-white rounded shadow-sm">
            <h5 class="fw-bold mb-4 text-start" style="color: #0f172a">
              Portfolio Composition (Illustrative)
            </h5>

            <!-- Responsive layout -->
            <div
              class="d-flex flex-column flex-md-row align-items-center align-items-md-start"
            >
              <!-- Chart -->
              <div class="chart-container mb-4 mb-md-0 me-md-4 flex-shrink-0">
                <Doughnut :data="chartData" :options="chartOptions" />
              </div>

              <!-- Legend -->
              <ul class="list-unstyled mb-0 flex-grow-1 w-100">
                <li
                  v-for="(item, index) in legendItems"
                  :key="index"
                  class="d-flex justify-content-between align-items-start mb-2"
                >
                  <div class="d-flex">
                    <span
                      class="legend-dot me-2 mt-2"
                      :style="{ backgroundColor: item.color }"
                    ></span>
                    <p
                      class="mb-0 text-start"
                      style="font-size: 14px; color: #334155"
                    >
                      {{ item.title }}
                      <span
                        v-if="item.subtitle"
                        class="fst-italic"
                        style="font-size: 14px; color: #64748b"
                      >
                        {{ item.subtitle }}
                      </span>
                    </p>
                  </div>
                  <span
                    class="fw-semibold"
                    style="color: #64748b; font-size: 14px"
                    >{{ item.value }}%</span
                  >
                </li>
              </ul>
            </div>

            <p class="text-muted small mt-3">
              Figures are illustrative to show strategic balance rather than
              exact amounts.
            </p>
          </div>
        </div>

        <!-- Revenue Distribution -->
        <div class="col-lg-6">
          <div
            class="info-card p-3"
            style="
              background-color: #ffffff;
              border-radius: 8px;
              box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
            "
          >
            <h5
              class="mb-4 text-start"
              style="font-size: 20px; font-weight: 400; color: #333"
            >
              Revenue Distribution by Region (Illustrative)
            </h5>

            <div style="position: relative">
              <canvas
                style="min-height: 200px; width: 100% !important"
                ref="chartRef"
              ></canvas>
            </div>

            <p
              class="mt-4 mb-0"
              style="font-size: 14px; color: #6c757d; line-height: 1.6"
            >
              Balanced mix with diversified exposure; values shown as
              approximate % to emphasize the principle rather than precise data.
            </p>
          </div>
        </div>
      </div>

      <!-- Bottom Section -->
      <div class="row g-4">
        <!-- Liquidity & Governance -->
        <div class="col-lg-6">
          <div class="info-card p-3">
            <h5
              class="fw-bold mb-4 text-start"
              style="font-size: 16px; color: #0f172a"
            >
              Liquidity & Governance
            </h5>
            <div class="checklist">
              <div class="checklist-item">
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 22 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  class="flex-shrink-0"
                >
                  <path
                    d="M17 11.249C17 14.9983 14.375 16.873 11.255 17.9603C11.0916 18.0157 10.9142 18.013 10.7525 17.9528C7.625 16.873 5 14.9983 5 11.249V5.99983C5 5.80096 5.07902 5.61022 5.21967 5.46959C5.36032 5.32896 5.55109 5.24996 5.75 5.24996C7.25 5.24996 9.125 4.35011 10.43 3.2103C10.5889 3.07457 10.791 3 11 3C11.209 3 11.4111 3.07457 11.57 3.2103C12.8825 4.35761 14.75 5.24996 16.25 5.24996C16.4489 5.24996 16.6397 5.32896 16.7803 5.46959C16.921 5.61022 17 5.80096 17 5.99983V11.249Z"
                    stroke="#DDB657"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M9 10.5L10.6667 12L14 9"
                    stroke="#DDB657"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <p
                  class="text-start w-100 mb-0"
                  style="font-size: 14px; color: #334155"
                >
                  Conservative approach to leverage, prioritizing
                  <span class="fw-bold" style="color: #334155">liquidity</span>
                  and strong cash flows.
                </p>
              </div>
              <div class="checklist-item">
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 22 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  class="flex-shrink-0"
                >
                  <path
                    d="M13.6663 16.9795V15.6507C13.6663 14.9459 13.3854 14.2699 12.8853 13.7715C12.3852 13.2732 11.7069 12.9932 10.9997 12.9932H6.99967C6.29243 12.9932 5.61415 13.2732 5.11406 13.7715C4.61396 14.2699 4.33301 14.9459 4.33301 15.6507V16.9795"
                    stroke="#DDB657"
                    stroke-width="1.0225"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M8.99967 10.3356C10.4724 10.3356 11.6663 9.14578 11.6663 7.67805C11.6663 6.21033 10.4724 5.02051 8.99967 5.02051C7.52692 5.02051 6.33301 6.21033 6.33301 7.67805C6.33301 9.14578 7.52692 10.3356 8.99967 10.3356Z"
                    stroke="#DDB657"
                    stroke-width="1.0225"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M17.667 16.9795V15.6508C17.6666 15.0619 17.4699 14.4899 17.1079 14.0246C16.7459 13.5592 16.2391 13.2268 15.667 13.0796"
                    stroke="#DDB657"
                    stroke-width="1.0225"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M13.667 5.10693C14.2406 5.2533 14.749 5.58576 15.1121 6.0519C15.4752 6.51804 15.6722 7.09134 15.6722 7.68143C15.6722 8.27152 15.4752 8.84483 15.1121 9.31097C14.749 9.77711 14.2406 10.1096 13.667 10.2559"
                    stroke="#DDB657"
                    stroke-width="1.0225"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>

                <p
                  class="text-start w-100 mb-0"
                  style="font-size: 14px; color: #334155"
                >
                  Governance via distributed family trusts, independent
                  oversight, and professional management supported by external
                  advisors.
                </p>
              </div>
              <div class="checklist-item">
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 22 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  class="flex-shrink-0"
                >
                  <path
                    d="M9.76311 13.0999C9.70955 12.8923 9.60132 12.7028 9.44969 12.5512C9.29806 12.3996 9.10857 12.2913 8.90094 12.2378L5.22003 11.2886C5.15723 11.2708 5.10196 11.2329 5.0626 11.1809C5.02325 11.1288 5.00195 11.0653 5.00195 11C5.00195 10.9347 5.02325 10.8712 5.0626 10.8191C5.10196 10.7671 5.15723 10.7292 5.22003 10.7114L8.90094 9.76163C9.1085 9.70812 9.29794 9.59998 9.44956 9.44846C9.60119 9.29694 9.70945 9.10758 9.76311 8.90005L10.7123 5.21914C10.7299 5.1561 10.7677 5.10055 10.8199 5.06098C10.872 5.02142 10.9357 5 11.0012 5C11.0667 5 11.1303 5.02142 11.1825 5.06098C11.2346 5.10055 11.2724 5.1561 11.2901 5.21914L12.2386 8.90005C12.2922 9.10769 12.4004 9.29718 12.5521 9.44881C12.7037 9.60044 12.8932 9.70867 13.1008 9.76223L16.7817 10.7108C16.845 10.7283 16.9008 10.766 16.9406 10.8182C16.9804 10.8705 17.002 10.9343 17.002 11C17.002 11.0657 16.9804 11.1295 16.9406 11.1817C16.9008 11.234 16.845 11.2717 16.7817 11.2892L13.1008 12.2378C12.8932 12.2913 12.7037 12.3996 12.5521 12.5512C12.4004 12.7028 12.2922 12.8923 12.2386 13.0999L11.2895 16.7809C11.2718 16.8439 11.234 16.8994 11.1819 16.939C11.1297 16.9786 11.0661 17 11.0006 17C10.9351 17 10.8714 16.9786 10.8193 16.939C10.7671 16.8994 10.7293 16.8439 10.7117 16.7809L9.76311 13.0999Z"
                    stroke="#DDB657"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M16.002 6V8"
                    stroke="#DDB657"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M17.002 7H15.002"
                    stroke="#DDB657"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M6.00195 14V15"
                    stroke="#DDB657"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M7.00195 15H6.00195"
                    stroke="#DDB657"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>

                <p
                  class="text-start w-100 mb-0"
                  style="font-size: 14px; color: #334155"
                >
                  Balanced growth that safeguards value for future generations.
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- Key Takeaways -->
        <div class="col-lg-6">
          <div class="info-card p-3">
            <h5
              class="fw-bold mb-4 text-start"
              style="font-size: 16px; color: #0f172a"
            >
              Key Takeaways
            </h5>
            <div class="checklist">
              <div class="checklist-item">
                <svg
                  width="18"
                  height="20"
                  viewBox="0 0 18 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  class="flex-shrink-0"
                >
                  <path
                    d="M4.3252 17.2101V4.23512C4.3252 3.85277 4.47708 3.48608 4.74745 3.21571C5.01781 2.94535 5.38451 2.79346 5.76686 2.79346H11.5335C11.9159 2.79346 12.2826 2.94535 12.5529 3.21571C12.8233 3.48608 12.9752 3.85277 12.9752 4.23512V17.2101H4.3252Z"
                    stroke="#DDB657"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M4.32474 10.002H2.88307C2.50072 10.002 2.13403 10.1538 1.86366 10.4242C1.5933 10.6946 1.44141 11.0613 1.44141 11.4436V15.7686C1.44141 16.151 1.5933 16.5177 1.86366 16.788C2.13403 17.0584 2.50072 17.2103 2.88307 17.2103H4.32474"
                    stroke="#DDB657"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M12.9746 7.83936H14.4163C14.7986 7.83936 15.1653 7.99125 15.4357 8.26161C15.7061 8.53198 15.8579 8.89867 15.8579 9.28102V15.7685C15.8579 16.1509 15.7061 16.5176 15.4357 16.7879C15.1653 17.0583 14.7986 17.2102 14.4163 17.2102H12.9746"
                    stroke="#DDB657"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M7.20801 5.67676H10.0908"
                    stroke="#DDB657"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M7.20801 8.56006H10.0908"
                    stroke="#DDB657"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M7.20801 11.4434H10.0908"
                    stroke="#DDB657"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M7.20801 14.3267H10.0908"
                    stroke="#DDB657"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>

                <p
                  class="text-start w-100 mb-0"
                  style="font-size: 14px; color: #334155"
                >
                  Multi-sector holdings spanning real assets, finance, trade,
                  healthcare, energy, and digital.
                </p>
              </div>
              <div class="checklist-item">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  class="flex-shrink-0"
                >
                  <path
                    d="M9.16667 12.4998H10.8333C11.2754 12.4998 11.6993 12.3242 12.0118 12.0117C12.3244 11.6991 12.5 11.2752 12.5 10.8332C12.5 10.3911 12.3244 9.96722 12.0118 9.65466C11.6993 9.3421 11.2754 9.1665 10.8333 9.1665H8.33333C7.83333 9.1665 7.41667 9.33317 7.16667 9.6665L2.5 14.1665"
                    stroke="#DDB657"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M5.83301 17.5002L7.16634 16.3336C7.41634 16.0002 7.83301 15.8336 8.33301 15.8336H11.6663C12.583 15.8336 13.4163 15.5002 13.9997 14.8336L17.833 11.1669C18.1546 10.863 18.3423 10.4438 18.3548 10.0015C18.3673 9.55926 18.2036 9.13013 17.8997 8.80856C17.5958 8.48698 17.1766 8.2993 16.7343 8.2868C16.292 8.2743 15.8629 8.438 15.5413 8.74189L12.0413 11.9919"
                    stroke="#DDB657"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M1.66699 13.3335L6.66699 18.3335"
                    stroke="#DDB657"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M13.3337 9.91683C14.6683 9.91683 15.7503 8.83485 15.7503 7.50016C15.7503 6.16547 14.6683 5.0835 13.3337 5.0835C11.999 5.0835 10.917 6.16547 10.917 7.50016C10.917 8.83485 11.999 9.91683 13.3337 9.91683Z"
                    stroke="#DDB657"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M5 6.6665C6.38071 6.6665 7.5 5.54722 7.5 4.1665C7.5 2.78579 6.38071 1.6665 5 1.6665C3.61929 1.6665 2.5 2.78579 2.5 4.1665C2.5 5.54722 3.61929 6.6665 5 6.6665Z"
                    stroke="#DDB657"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <p
                  class="text-start w-100 mb-0"
                  style="font-size: 14px; color: #334155"
                >
                  Prudent allocation designed to maintain liquidity and
                  sustainable returns.
                </p>
              </div>
              <div class="checklist-item">
                <svg
                  width="19"
                  height="20"
                  viewBox="0 0 19 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  class="flex-shrink-0"
                >
                  <path
                    d="M2.36133 2.91602V15.5097C2.36133 15.9273 2.52718 16.3277 2.82241 16.6229C3.11763 16.9181 3.51804 17.084 3.93554 17.084H16.5293"
                    stroke="#DDB657"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M14.9551 7.63867L11.0195 11.5742L7.87109 8.42578L5.50977 10.7871"
                    stroke="#DDB657"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <p
                  class="text-start w-100 mb-0"
                  style="font-size: 14px; color: #334155"
                >
                  Diversified revenues with no single sector or geography
                  dominating performance.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="apart about-sec default-padding"
      style="background-color: #f9fafb"
    >
      <div class="container">
        <div
          class="d-flex flex-column gap-5 justify-content-center align-items-center mb-4"
        >
          <div class="sub-heading d-flex flex-column align-items-center">
            <h3 class="text-center">Future Development Plan</h3>
            <p class="text-center" style="color: #475569">
              Advancing strategic pillars across food security, healthcare,
              manufacturing, digital ecosystems, and infrastructure.
            </p>
          </div>
        </div>
        <div class="d-flex flex-column gap-3">
          <div class="row g-4">
            <div
              v-for="(card, index) in cards"
              :key="index"
              class="col-lg-4 col-md-6 d-flex"
            >
              <div
                class="service-card hover-lift d-flex flex-column gap-3 w-100 border-0"
                style="
                  border-color: #f5e9cd;
                  border-radius: 8px;
                  padding: 24px;
                  box-shadow: 0px 3px 4px 0px rgba(0, 0, 0, 0.08);
                "
              >
                <div class="d-flex align-items-center gap-3">
                  <div v-html="card.icon"></div>
                  <h4 class="text-start mb-0">{{ card.title }}</h4>
                </div>
                <div v-if="card.text" class="card-content">
                  <p class="mb-0 text-start">{{ card.text }}</p>
                </div>
                <div v-if="card.points" class="d-flex flex-column gap-3">
                  <div
                    v-for="(point, index) in card.points"
                    :key="index"
                    class="d-flex gap-2 align-items-center"
                  >
                    <div
                      class="flex-shrink-0"
                      style="
                        width: 8px;
                        height: 8px;
                        border-radius: 9px;
                        background-color: #334155;
                      "
                    ></div>
                    <p class="mb-0 text-start" style="color: #334155">
                      {{ point }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="p-4 bg-white d-flex align-items-center justify-content-between"
          style="
            margin-top: 40px;
            border: 1px solid #e2e8f0;
            border-radius: 16px;
          "
        >
          <div class="d-flex flex-column gap-1">
            <p class="mb-0" style="color: #0f172a">Investor enquiries</p>
            <p class="mb-0" style="font-size: 14px; color: #475569">
              Reach our team for further materials or partnership discussions.
            </p>
          </div>
          <router-link
            to="/getTouch"
            class="text-white border-0"
            style="
              background-color: #ddb657;
              border-radius: 12px;
              padding: 16px 20px;
              font-size: 16px;
            "
          >
            Get in touch
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from "vue";
import { Doughnut } from "vue-chartjs";
import ScrollReveal from 'scrollreveal';
import {
  Chart,
  BarController,
  BarElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
  ArcElement,
} from "chart.js";

Chart.register(
  BarController,
  BarElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
  ArcElement
);

const chartRef = ref(null);
let chartInstance = null;

const chartData = {
  labels: [
    "Real Assets",
    "Financial Services & Private Capital",
    "Trade, Commodities & Logistics",
    "Healthcare, Education & Community Services",
    "Agriculture, Food & Consumer Goods",
    "Energy, Environment & Digital Transformation",
  ],
  datasets: [
    {
      data: [33, 20, 18, 12, 9, 8],
      backgroundColor: [
        "#F4A71C",
        "#34B27B",
        "#64A8F1",
        "#F97027",
        "#B08DEF",
        "#1FA47A",
      ],
      borderWidth: 1,
      borderColor: "#fff",
      hoverOffset: 8,
      cutout: "70%",
    },
  ],
};

const chartOptions = {
  responsive: true,
  plugins: {
    legend: { display: false },
    tooltip: { enabled: true },
  },
};

const legendItems = [
  {
    title: "Real Assets",
    subtitle: "(Real Estate, Construction, Infrastructure)",
    value: 33,
    color: "#F59E0B",
  },
  {
    title: "Financial Services & Private Capital",
    value: 20,
    color: "#22C55E",
  },
  {
    title: "Trade, Commodities & Logistics",
    value: 18,
    color: "#60A5FA",
  },
  {
    title: "Healthcare, Education & Community Services",
    value: 12,
    color: "#F97316",
  },
  {
    title: "Agriculture, Food & Consumer Goods",
    value: 9,
    color: "#A78BFA",
  },
  {
    title: "Energy, Environment & Digital Transformation",
    value: 8,
    color: "#10B981",
  },
];

const cards = [
  {
    title: "Food & Agriculture (Halal & Co. + Food Security)",
    text: "Flagship initiative: Halal & Co., creating a cross-regional halal-ready food platform linking Chinese production and Middle Eastern markets. Modern agriculture (e.g., mobile farms & hydroponics) to strengthen food security, traceability, and trade corridors.",
    icon: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.8742 18.1098C10.5331 18.1139 9.23943 17.6137 8.24981 16.7086C7.26019 15.8035 6.64689 14.5596 6.53154 13.2234C6.41619 11.8873 6.80722 10.5566 7.62708 9.49527C8.44693 8.43395 9.63572 7.71952 10.9577 7.49368C15.3111 6.65355 16.4567 6.2564 17.9842 4.3623C18.7479 5.8898 19.5117 7.55478 19.5117 10.4723C19.5117 14.6729 15.861 18.1098 11.8742 18.1098Z" stroke="#DDB657" stroke-width="1.5275" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M5 18.873C5 16.582 6.41279 14.7798 8.87945 14.291C10.7275 13.9245 12.6367 12.7637 13.4004 12" stroke="#DDB657" stroke-width="1.5275" stroke-linecap="round" stroke-linejoin="round"/>
</svg>


`,
  },
  {
    title: "Healthcare & Pharmaceuticals",
    text: "Expansion into pharmaceuticals including generics, biotech collaborations, and distribution platforms. Broaden medical disposables supply chains and develop Arab–Asia collaborations for advanced care delivery.",
    icon: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M19 14C20.49 12.54 22 10.79 22 8.5C22 7.04131 21.4205 5.64236 20.3891 4.61091C19.3576 3.57946 17.9587 3 16.5 3C14.74 3 13.5 3.5 12 5C10.5 3.5 9.26 3 7.5 3C6.04131 3 4.64236 3.57946 3.61091 4.61091C2.57946 5.64236 2 7.04131 2 8.5C2 10.8 3.5 12.55 5 14L12 21L19 14Z" stroke="#DDB657" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M3.21973 12H9.49973L9.99973 11L11.9997 15.5L13.9997 8.5L15.4997 12H20.7697" stroke="#DDB657" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>


`,
  },
  {
    title: "Manufacturing & Consumer Goods",
    text: "Premium cosmetics, household products, and pet care positioned as dedicated divisions. Strengthen proprietary brands and global private-label supply with sustainable packaging and export-driven products.",
    icon: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4 18.4C4 18.8243 4.16857 19.2313 4.46863 19.5314C4.76869 19.8314 5.17565 20 5.6 20H18.4C18.8243 20 19.2313 19.8314 19.5314 19.5314C19.8314 19.2313 20 18.8243 20 18.4V8.8L14.4 12.8V8.8L8.8 12.8V5.6C8.8 5.17565 8.63143 4.76869 8.33137 4.46863C8.03131 4.16857 7.62435 4 7.2 4H5.6C5.17565 4 4.76869 4.16857 4.46863 4.46863C4.16857 4.76869 4 5.17565 4 5.6V18.4Z" stroke="#DDB657" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M16 17H17" stroke="#DDB657" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12 17H13" stroke="#DDB657" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M8 17H9" stroke="#DDB657" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>


`,
  },
  {
    title: "Digital & IT Ecosystems",
    text: "Build integrated ecosystems across smart factories, IT services, e-learning, and fintech-enabled trade. Develop analytics to drive decision-making, efficiency, and scalability with hubs in UAE, Jordan, and Riyadh.",
    icon: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18 4H6C4.89543 4 4 4.89543 4 6V18C4 19.1046 4.89543 20 6 20H18C19.1046 20 20 19.1046 20 18V6C20 4.89543 19.1046 4 18 4Z" stroke="#DDB657" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M14 9H10C9.44772 9 9 9.44772 9 10V14C9 14.5523 9.44772 15 10 15H14C14.5523 15 15 14.5523 15 14V10C15 9.44772 14.5523 9 14 9Z" stroke="#DDB657" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M15 2V4" stroke="#DDB657" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M15 20V22" stroke="#DDB657" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M2 15H4" stroke="#DDB657" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M2 9H4" stroke="#DDB657" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M20 15H22" stroke="#DDB657" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M20 9H22" stroke="#DDB657" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M9 2V4" stroke="#DDB657" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M9 20V22" stroke="#DDB657" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>


`,
  },
  {
    title: "Infrastructure & Industrial Development",
    text: "Expansion in logistics, power infrastructure, real estate, and construction engineering. North Africa, Jordan, and Gulf hubs act as anchors for mega-projects and regional development.",
    icon: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6 21.2316V4.61442C6 4.12473 6.21071 3.65511 6.58579 3.30885C6.96086 2.96259 7.46957 2.76807 8 2.76807H16C16.5304 2.76807 17.0391 2.96259 17.4142 3.30885C17.7893 3.65511 18 4.12473 18 4.61442V21.2316H6Z" stroke="#DDB657" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M6 12H4C3.46957 12 2.96086 12.1945 2.58579 12.5408C2.21071 12.887 2 13.3567 2 13.8463V19.3854C2 19.8751 2.21071 20.3447 2.58579 20.691C2.96086 21.0372 3.46957 21.2317 4 21.2317H6" stroke="#DDB657" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M18 9.23047H20C20.5304 9.23047 21.0391 9.42499 21.4142 9.77125C21.7893 10.1175 22 10.5871 22 11.0768V19.3854C22 19.8751 21.7893 20.3447 21.4142 20.691C21.0391 21.0372 20.5304 21.2317 20 21.2317H18" stroke="#DDB657" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M10 6.46094H13.9993" stroke="#DDB657" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M10 10.1538H13.9993" stroke="#DDB657" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M10 13.8462H13.9993" stroke="#DDB657" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M10 17.5391H13.9993" stroke="#DDB657" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`,
  },
  {
    title: "Strategic Development Pillars",
    points: [
      "Infrastructure & Industrial Development",
      "Food & Agriculture",
      "Healthcare & Pharmaceuticals",
      "Manufacturing & Consumer Goods",
      "Digital & IT Ecosystems",
    ],
    icon: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 22H21" stroke="#DDB657" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M6 18V11" stroke="#DDB657" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M10 18V11" stroke="#DDB657" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M14 18V11" stroke="#DDB657" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M18 18V11" stroke="#DDB657" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12 2L20 7H4L12 2Z" stroke="#DDB657" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

`,
  },
];

onMounted(() => {
  window.scrollTo({ top: 0, behavior: "smooth" });

  // Initialize ScrollReveal
  const sr = ScrollReveal({
    origin: 'bottom',
    distance: '60px',
    duration: 1500,
    delay: 200,
    reset: false
  });

  // Hero section animations
  sr.reveal('.hero h1', {
    origin: 'left',
    delay: 200,
    distance: '80px'
  });

  sr.reveal('.hero p', {
    delay: 400
  });

  // About section animations
  sr.reveal('.about .sub-heading', {
    origin: 'left',
    delay: 200
  });

  sr.reveal('.about p', {
    delay: 400,
    interval: 200
  });

  sr.reveal('.about img', {
    origin: 'right',
    delay: 600
  });

  // Financial Highlights section animations
  sr.reveal('.text-center.mb-5', {
    delay: 200
  });

  sr.reveal('.info-card', {
    delay: 400,
    interval: 200,
    scale: 0.95
  });

  // Charts section animations
  sr.reveal('.chart-container', {
    delay: 600,
    scale: 0.9
  });

  sr.reveal('.info-card .checklist-item', {
    delay: 400,
    interval: 200,
    distance: '40px'
  });

  // Future Development Plan section animations
  sr.reveal('.apart .sub-heading', {
    delay: 200
  });

  sr.reveal('.service-card', {
    delay: 400,
    interval: 200,
    scale: 0.95
  });

  sr.reveal('.bg-white', {
    delay: 600,
    distance: '40px'
  });

  if (chartRef.value) {
    const ctx = chartRef.value.getContext("2d");

    // Destroy existing chart (safety)
    if (chartInstance) chartInstance.destroy();

    chartInstance = new Chart(ctx, {
      type: "bar",
      data: {
        labels: ["MENA", "Asia", "Other Regions"],
        datasets: [
          {
            data: [40, 34, 25],
            backgroundColor: "#000000",
            borderRadius: 8,
            barThickness: 80,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: true,
        aspectRatio: 2,
        plugins: {
          legend: { display: false },
          title: { display: false },
          tooltip: {
            backgroundColor: "#000000",
            padding: 12,
            callbacks: {
              label: (context) => `${context.parsed.y}%`,
            },
          },
        },
        scales: {
          y: {
            beginAtZero: true,
            max: 40,
            ticks: {
              stepSize: 10,
              font: { size: 12 },
              color: "#666",
            },
            grid: {
              color: "#e0e0e0",
              drawBorder: true,
              borderDash: [5, 5],
            },
            border: {
              display: true,
              color: "#666666",
              width: 2,
            },
          },
          x: {
            ticks: {
              font: { size: 13 },
              color: "#333",
            },
            grid: { display: false, drawBorder: true },
            border: {
              display: true,
              color: "#666666",
              width: 2,
            },
          },
        },
        layout: { padding: { top: 10, bottom: 10 } },
      },
    });
  }
});

onBeforeUnmount(() => {
  if (chartInstance) chartInstance.destroy();
});
</script>

<style scoped>
.hero {
  aspect-ratio: 3 / 0.8;
  width: 100%;
  min-height: 400px;
}

.content {
  width: 100%;
  text-align: center;
  margin: auto;
}
.paragraph-width {
  width: 55%;
}
@media (max-width: 700px) {
  .paragraph-width {
    width: 100%;
  }
}
.info-card,
.chart-card {
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  height: 100%;
  transition: box-shadow 0.3s ease;
}

.info-card:hover,
.chart-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}

/* Icon Box */
.icon-box {
  width: 48px;
  height: 48px;
  background: #fffbeb;
  border-radius: 12px;
  border: 1px solid #fef3c7;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

/* Bar Chart */
.bar-chart {
  display: flex;
  align-items: flex-end;
  justify-content: space-around;
  height: 280px;
  gap: 30px;
  padding: 20px 0;
}

.bar-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.bar-label {
  font-size: 13px;
  font-weight: 500;
  color: #6b7280;
  text-align: center;
}

.bar-container {
  width: 100%;
  max-width: 80px;
  height: 200px;
  background: #f3f4f6;
  border-radius: 8px 8px 0 0;
  position: relative;
  display: flex;
  align-items: flex-end;
}

.bar-fill {
  width: 100%;
  background: #1f2937;
  border-radius: 6px 6px 0 0;
  transition: height 0.3s ease;
}

.bar-value {
  font-size: 14px;
  font-weight: 600;
  color: #1f2937;
}

/* Checklist */
.checklist {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.checklist-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  color: #4b5563;
  line-height: 1.6;
}

.check-icon {
  width: 24px;
  height: 24px;
  background: #fef3c7;
  color: #f59e0b;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-weight: bold;
  font-size: 14px;
}

/* Numbered List */
.numbered-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.numbered-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  color: #4b5563;
  line-height: 1.6;
}

.number-badge {
  width: 28px;
  height: 28px;
  background: #fef3c7;
  color: #f59e0b;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-weight: bold;
  font-size: 14px;
}

/* Responsive */
@media (max-width: 768px) {
  .bar-chart {
    gap: 15px;
  }

  .bar-container {
    max-width: 60px;
  }
}

/* Animation styles */
.hero h1,
.hero p,
.about .sub-heading,
.about p,
.about img,
.text-center.mb-5,
.info-card,
.chart-container,
.info-card .checklist-item,
.apart .sub-heading,
.service-card,
.bg-white {
  visibility: hidden;
}

.chart-container {
  width: 220px;
  height: 220px;
}

.legend-dot {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
}
</style>
